import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base.component';
import { DataService } from '../service/data.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.less']
})
export class ListComponent extends BaseComponent implements OnInit {

  constructor(dataService:DataService) {
    super(dataService);
  }

  ngOnInit() {
  }

}
